---
en:
  liquidity:
    actual: Actual
    base: Base
    data_sources:
      owner: Owner
      simulation: Simulation
    expected: Expected
    file_processed: File processed
    file_too_large: File is too large
    invalid_file: The file could not be read. It may be corrupted or in the wrong format.
    liquidity: Liquidity planning
    mean_historical: Mean of historical data
    no_data_for_chart: There's no data for this chart for the selected filters
    production: Production
    pxx_production: P%{number} Production
    pxx_spot_price: P%{number} Spot price
    revenue: Revenue
    sim_high: Simulated High
    sim_low: Simulated Low
    simulated_production: Simulated production
    simulated_revenue_development: Revenue development
    spot_price: Spot price
    variation: Variation
